class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    // Audit fix: some header/search configurations can omit modal controls.
    // Guard initialization so product pages do not raise repeatable JS errors.
    if (!this.detailsContainer || !this.summaryToggle || !this.closeButton) return;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.closeButton.addEventListener(
      'click',
      this.close.bind(this)
    );
    if (this.resetButton) {
      this.resetButton.addEventListener(
        'click',
        this.reset.bind(this)
      );
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');

    if (!details) return;

    details.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    if (!this.detailsContainer) return;
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus();
    if (this.detailsContainer) this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    const searchInput = this.querySelector('input[type="search"]');
    if (searchInput) searchInput.value = '';
  }
}

customElements.define('search-modal', SearchModal);
